module.exports = __webpack_public_path__ + "static/media/chatroomWhite.947ccb7b.svg";